import { getApi } from 'apis';

export const getAllJobGrades = async (params: any) => {
	return await getApi('/jobGrade', params);
};
